import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../modules/auth'
import {
  getAuthRoles,
  ModuleAuthRolesModel,
  setActiveRole,
} from '../../modules/auth/core/AuthHelpers'
import {useModule} from '../modules'

type Props = {
  className?: string
}

const hideIrrelevantLegacyPreviewRole = (moduleCode: string | undefined, role: string) =>
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_ALLOW_LEGACY_MODULE_PREVIEW === 'true' &&
  moduleCode === 'assessment' &&
  role.trim().toLocaleUpperCase('tr-TR').includes('ANKET')

export function RoleSwitcher({className = 'form-select'}: Props) {
  const navigate = useNavigate()
  const {switchRole} = useAuth()
  const {isModuleSession, defaultRoute, moduleCode} = useModule()
  const [loading, setLoading] = useState(false)
  const authRoles = getAuthRoles()
  const visibleRoles =
    authRoles?.roles.filter(
      (role) => !hideIrrelevantLegacyPreviewRole(moduleCode, role.role || '')
    ) || []

  if (!authRoles || visibleRoles.length <= 1) {
    return null
  }

  const moduleRoles = isModuleSession ? (authRoles as ModuleAuthRolesModel) : undefined
  const selectedValue = moduleRoles
    ? moduleRoles.activeUserRoleId?.toString() || ''
    : authRoles.activeRoleIndex.toString()

  const handleChange = async (rawValue: string) => {
    const value = Number(rawValue)
    if (!Number.isInteger(value)) {
      return
    }

    if (!isModuleSession) {
      navigate('/dashboard')
      setActiveRole(value)
      window.location.reload()
      return
    }

    const roleIndex = authRoles.roles.findIndex((role) => role.userRoleId === value)
    if (roleIndex < 0) {
      return
    }

    setLoading(true)
    try {
      const switched = await switchRole(value, roleIndex)
      if (switched) {
        navigate(defaultRoute, {replace: true})
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <select
      aria-label='Rol seçimi'
      className={className}
      value={selectedValue}
      onChange={(event) => handleChange(event.target.value)}
      disabled={loading}
    >
      {visibleRoles.map((role) => {
        const index = authRoles.roles.indexOf(role)
        const value = isModuleSession ? role.userRoleId : index
        return (
          <option
            key={isModuleSession ? role.userRoleId || `${role.role}-${index}` : index}
            value={value}
            disabled={isModuleSession && typeof role.userRoleId !== 'number'}
          >
            {role.role}
          </option>
        )
      })}
    </select>
  )
}
